export const currentlyUsed = "attualmente in uso";
export const expiredLinkSubTitle =
  "Ci dispiace, ma questo link non è più valido.";
export const expiredLinkTitle = "Link scaduto";
export const extension = "Estensione";
export const extensionAccepted = ".docx, .pdf, .txt";
export const forgotPassword = "Password dimenticata?";
export const insertAnArgument = "Inserisci un argomento...";
export const labelAddCode = "Aggiungi codice";
export const labelAddCodeSubtitle = "Seleziona uno o più codici dal database";
export const labelAddSourceArchive = "Aggiungi fonte da Archivio";
export const labelAddSourceArchiveSubTitle =
  "Seleziona una o più fonti dall’archivio";
export const labelAddSourceFor = "Fonte aggiunta da";
export const labelAddSourcePrivate = "Carica fonte privata";
export const labelAdmin = "Admin";
export const labelAnswer = "Risposta";
export const labelAnswers = "Risposte";
export const labelAlmenoOttoCaratteri = "Almeno 8 caratteri";
export const labelAlmenoUnaLetteraMaiuscola = "Almeno 1 lettera maiuscola";
export const labelAlmenoUnaLetteraMinuscola = "Almeno 1 lettera minuscola";
export const labelAlmenoUnNumero = "Almeno 1 numero";
export const labelAnagrafica = "Anagrafica";
export const labelAperta = "Aperta";
export const labelArchive = "ARCHIVE";
export const labelArchiviata = "Archiviata";
export const labelArchivio = "Archivio";
export const labelArgsWithExample = "Argomenta con esempi";
export const labelArticles = "articoli";
export const labelAuthor = "Autore";
export const labelChatEmptyFirstRow = "Non hai risposte salvate.";
export const labelChatEmptySecondRow = "Avvia il chatbot per iniziare.";
export const labelClassificazione = "Classificazione";
export const labelCode = "Codice";
export const labelCodes = "Codici";
export const labelCodex = "CODEX";
export const labelCognome = "Cognome";
export const labelCopy = "Copia";
export const labelCopyRight = "Edizioni Simone©2024 - All rights reserved.";
export const labelCopyRightChat =
  "Esophia©2024 commette errori. Verifica sempre le informazioni importanti.";
export const labelCorrect = "Corretto";
export const labelCreatedBy = "Creato da";
export const labelDate = "Data";
export const labelDebole = "Debole";
export const labelDelete = "Elimina";
export const labelDeleteAccount = "Elimina Account";
export const labelDeleteAccountSubtitle =
  "Sei sicuro di voler eliminare questo account?<br>Inserisci la password per confermare";
export const labelProfileDeleteAccount =
  "Questo significa che non potrai più accedere alle tue attività in piattaforma.";
export const labelDescription = "Descrizione";
export const labelDi = "di ";
export const labelDimensionFile = "KB";
export const labelDownload = "Scarica";
export const labelDragYourFile = "Trascina qui il tuo file oppure";
export const labelEditor = "Editor";

export const labelElement = "element";
export const labelElementsViewed = "Stai visualizzando ";
export const labelEmail = "Email";
export const labelError = "Errore";
export const labelExtendedChat = "Espandi Chat";
export const labelReady = "Pronto";
export const labelReduceChat = "Riduci Chat";
export const labelExtendedContents = "Estendi contenuto";
export const labelFonte = "Fonte";
export const labelFonteUsed = "fonte utilizzata";
export const labelFonti = "Fonti";
export const labelFontiUsed = "fonti utilizzate";
export const labelForte = "Forte";
export const labelForward = "Rispondi";
export const labelAnswerLocker = "Risposta bloccata (appartiene a una chat resettata)";
export const labelGoToMessage = "Vai al messaggio";
export const labelFoundIn = "Appare in";
export const labelHeaderSuggestionsPassword = "Scegli una password";
export const labelId = "ID";
export const labelISBN = "ISBN";
export const labelInfo = "Info";
export const labelIniziaADigitare = "Inizia a digitare";
export const labelLaPasswordDeveContenere = "La password deve contenere";
export const labelLastUpdate = "Ultima modifica";
export const labelLeaveProject = "Abbandona";
export const labelLogout = "Logout";
export const labelMedio = "Medio";
export const labelNewQuiz = "Crea quiz";
export const labelNewSummary = "Crea riassunto";
export const labelNoCodes = "Nessun codice trovato";
export const labelNoDescription = "Nessuna descrizione";
export const labelNome = "Nome";
export const labelNoResults = "Nessun risultato trovato";
export const labelNoSource = "Nessuna fonte";
export const labelNoSourceUsed = "Nessuna fonte utilizzata";
export const labelNoSourceFound = "Nessuna fonte trovata";
export const labelOrderBy = "Ordina per";
export const labelOwner = "Proprietario";
export const labelPageNotFound = "Pagina non trovata";
export const labelPageNotFoundSubtitle =
  "Ops! Sembra che la pagina che stai cercando non esista o sia stata spostata.";
export const labelPendingUpdate = "Hai effettuato delle modifiche";
export const labelPrivate = "Privata";
export const labelPrivates = "PRIVATE";
export const labelProcessing = "Elaborazione...";
export const labelProfilo = "Profilo";
export const labelProjects = "Progetti";
export const labelProjectsEmptyFirstRow = "Non ci sono ancora progetti qui.";
export const labelProjectsEmptySecondRow = "Creane subito uno!";
export const labelRefresh = "Rigenera";
export const labelRename = "Rinomina";
export const labelReport = "Segnala";
export const labelReports = "Segnalazioni";
export const labelReportsEmpty =
  "Le segnalazioni della piattaforma verranno mostrate qui";
export const labelResendEmail = "Invita di nuovo";
export const labelResults = "Risultati";
export const labelRimuovi = "Rimuovi";
export const labelRuolo = "Ruolo";
export const labelSave = "Salva";
export const labelSavedFor = "Salvata da";
export const labelSaveRes = "Risposte salvate";
export const labelSchematize = "Schematizza";
export const labelSelectAll = "Seleziona tutte";
export const labelSelected = "selezionati";
export const labelSelect = "Selezionate: ";
export const labelSelezionato = "Selezionato";
export const labelShare = "Condividi";
export const labelSicuroDiUscire =
  "Vuoi davvero uscire?\n I dati non salvati andranno persi.";
export const labelSourcesEmpty =
  "I dati inseriti in piattaforma verranno mostrati qui";
export const labelSourceDelete = "La fonte è stata eliminata";
export const labelSourceDeleteTree = "Eliminata";
export const labelSourceUpdateTooltip = "La fonte è stata aggiornata";
export const labelSourceUpdate = "Aggiornata";
export const labelSuperAdmin = "superadmin";
export const labelState = "Stato";
export const labelToneOfVoce = "TONE OF VOICE";
export const labelTipologia = "Tipologia";
export const labelTopic = "Topic";
export const labelTopicEmpty =
  "I topic della piattaforma verranno mostrati qui";
export const labelUpdate = "Modifica";
export const labelUploadeBy = "Caricato da";
export const labelUploadFile = "clicca per caricare";
export const labelUser = "User";
export const labelUserEmpty =
  "Gli utenti della piattaforma verranno mostrati qui";
export const labelUserNotFound = "Nessun utente trovato";
export const labelUsers = "Utenti";
export const labelUtente = "Utente";
export const lessRecent = "Meno recenti";
export const lock = "Privato";
export const loginSubtitle = "Inserisci le tue credenziali";
export const mostRecent = "Più recenti";
export const nameAsc = "Nome A-Z";
export const nameDesc = "Nome Z-A";
export const noAccount = "Non hai un account?";
export const notLogged404SubTitle =
  "Ops! Sembra che la pagina che stai cercando \n non esista o sia stata spostata.";
export const notLogged404Title = "Pagina non trovata";
export const notReceiveEmail = "Non hai ricevuto nessuna email?";
export const RegisterSubTitle =
  "Inserisci i dati richiesti per la registrazione";
export const RegisterTitle = "Registrati";
export const rememberMe = "Ricordami";
export const resendEmail = "Invia di nuovo";
export const ResetPasswordSubTitle =
  "Inserisci la tua email per recuperare la password";
export const ResetPasswordTitle = "Reimposta Password";
export const setPasswordSubTitle = "Scegli una nuova password per accedere";
export const setPasswordTitle = "Nuova Password";
export const archive = "Archivio";
export const simonBot = "SimonBot";
export const shared = "Condiviso";
export const startToMessage = "Inizia a digitare...";
export const privateSource = "Privata";
export const codex = "Codice";
export const supportedExt =
  "Estensioni supportate: .docx, .pdf e .txt. Dimensione massima 150MB";
export const Titlelogin = "Accedi";
export const valueAperta = "aperta";
export const valueArchive = "archive";
export const valueArchiviata = "archiviata";
export const valuePrivate = "private";
export const valueShared = "shared";
export const valueDatabase = "database";
export const verifyEmailSubTitle = "Ti abbiamo inviato un' email all'indirizzo";
export const verifyEmailSubTitle2 =
  ". Clicca sul pulsante all'interno dell'email per verificare l'account.";
export const verifyEmailTitle = "Verifica email";
export const subtitleDetailResponse =
  "Rivedi le informazioni della risposta salvata";
export const labelQuiz = "quiz";
export const labelRiassunto = "riassunto";
export const labelSchematizza = "schematizza";
export const labelEstendi = "estendi";
export const labelArgomenta = "argomenta";
export const labelNoAnswerFromAI = "Non posso rispondere a questa domanda.";
export const labelAnswerTypeArticolo = "Articolo";
